import { render, staticRenderFns } from "./ContractEditor.vue?vue&type=template&id=bedab2fa&scoped=true&"
import script from "./ContractEditor.vue?vue&type=script&lang=js&"
export * from "./ContractEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedab2fa",
  null
  
)

export default component.exports